export default __webpack_public_path__ + "static/media/Delete.c4db0866.svg";